export default __webpack_public_path__ + "static/media/internOrange.bc34e4f1.svg";